"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atCoder = void 0;
// @ts-nocheck
var atCoder = [
    {
        artifact_id: 10199338,
        type: "CLINICAL",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11302449,
                    procedure_name: null,
                    procedure_code: "76856",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1,
                    evidence: [],
                    modifiers: {
                        confidence: 0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0,
                        primary_code_confidence: 0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: false
                }
            ],
            confidence: -1
        },
        modifiers: {
            confidence: -1,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1,
            primary_code_confidence: -1,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10203971,
        type: "PREDICTION",
        identifier: "3360968",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 11307119,
                    procedure_name: null,
                    procedure_code: "76830",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    automate: false,
                    confidence: 0.91,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.034915353073792794,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ultrasound transvagin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 32,
                                        end: 55,
                                        level: "ngram",
                                        content: "Ultrasound Transvaginal"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.026497717133120238,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ultrasound transvagin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 32,
                                        end: 55,
                                        level: "ngram",
                                        content: "Ultrasound Transvaginal"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.016900660739697197,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "pelvic transvagin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 25,
                                        end: 55,
                                        level: "ngram",
                                        content: "Pelvic Ultrasound Transvaginal"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.01625104640847154,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "ultrasound 76830",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 32,
                                        end: 62,
                                        level: "ngram",
                                        content: "Ultrasound Transvaginal (76830"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.01226950164579945,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "76830",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 57,
                                        end: 62,
                                        level: "ngram",
                                        content: "76830"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.010516250567659157,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "pelvic 76830",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 25,
                                        end: 62,
                                        level: "ngram",
                                        content: "Pelvic Ultrasound Transvaginal (76830"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.009503761175265982,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "transvagin 76830",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 43,
                                        end: 62,
                                        level: "ngram",
                                        content: "Transvaginal (76830"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.006911165845191798,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "transvagin indic",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 43,
                                        end: 78,
                                        level: "ngram",
                                        content: "Transvaginal (76830)\n   INDICATIONS"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.006714166772901369,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "pelvic transvagin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 25,
                                        end: 55,
                                        level: "ngram",
                                        content: "Pelvic Ultrasound Transvaginal"
                                    },
                                    {
                                        start: 18,
                                        end: 87,
                                        level: "sentence",
                                        content: "       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.006238551685208157,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "perform transvagin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 8,
                                        end: 55,
                                        level: "ngram",
                                        content: "PERFORMED\n       Pelvic Ultrasound Transvaginal"
                                    },
                                    {
                                        start: 0,
                                        end: 87,
                                        level: "sentence",
                                        content: "  TESTS PERFORMED\n       Pelvic Ultrasound Transvaginal (76830)\n   INDICATIONS/REASONS "
                                    }
                                ]
                            }
                        }
                    ],
                    modifiers: {
                        confidence: 0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0,
                        primary_code_confidence: 0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: 0.91
        },
        modifiers: {
            confidence: 0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.72,
            primary_code_confidence: 0.97,
            primary_predicted_code: "N97.9",
            automate: false,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "N97.9",
                    automate: false,
                    confidence: 0.72,
                    sequence_number: null,
                    type: null,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.03684521443722452,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil find",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 155,
                                        level: "ngram",
                                        content: "infertility\n   \n   FINDINGS"
                                    },
                                    {
                                        start: 97,
                                        end: 155,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.032156570064761934,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil find",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 155,
                                        level: "ngram",
                                        content: "infertility\n   \n   FINDINGS"
                                    },
                                    {
                                        start: 97,
                                        end: 155,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.029251550076432157,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 139,
                                        level: "ngram",
                                        content: "infertility"
                                    },
                                    {
                                        start: 97,
                                        end: 139,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.028055604445263248,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "for infertil",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 124,
                                        end: 139,
                                        level: "ngram",
                                        content: "for infertility"
                                    },
                                    {
                                        start: 97,
                                        end: 139,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.025378560968894997,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil uteru",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 169,
                                        level: "ngram",
                                        content: "infertility\n   \n   FINDINGS\n       Uterus"
                                    },
                                    {
                                        start: 97,
                                        end: 169,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility\n   \n   FINDINGS\n       Uterus"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Categorical",
                            score: 0.02124765283633915,
                            feature: {
                                category: "Pelvis",
                                field: "body_region",
                                type: "categorical"
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.013708222831058934,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil uteru",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 169,
                                        level: "ngram",
                                        content: "infertility\n   \n   FINDINGS\n       Uterus"
                                    },
                                    {
                                        start: 97,
                                        end: 169,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility\n   \n   FINDINGS\n       Uterus"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.010641634464522032,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "infertil find",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 128,
                                        end: 155,
                                        level: "ngram",
                                        content: "infertility\n   \n   FINDINGS"
                                    },
                                    {
                                        start: 97,
                                        end: 155,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.010082192037320824,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "for infertil",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 124,
                                        end: 139,
                                        level: "ngram",
                                        content: "for infertility"
                                    },
                                    {
                                        start: 97,
                                        end: 139,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.007357190147892673,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "for",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 87,
                                        end: 90,
                                        level: "ngram",
                                        content: "FOR"
                                    },
                                    {
                                        start: 87,
                                        end: 96,
                                        level: "sentence",
                                        content: "FOR TESTS"
                                    },
                                    {
                                        start: 124,
                                        end: 127,
                                        level: "ngram",
                                        content: "for"
                                    },
                                    {
                                        start: 97,
                                        end: 139,
                                        level: "sentence",
                                        content: "       Baseline assessment for infertility"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 10199334,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11302444,
                    procedure_name: null,
                    procedure_code: "76856",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1,
                    evidence: [],
                    modifiers: {
                        confidence: 0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0,
                        primary_code_confidence: 0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: -1
        },
        modifiers: {
            confidence: -1,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1,
            primary_code_confidence: -1,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10206531,
        type: "ASSEMBLED",
        identifier: "3360968",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 11309673,
                    procedure_name: null,
                    procedure_code: "76856",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    automate: true,
                    confidence: 1,
                    evidence: [],
                    modifiers: {
                        confidence: 0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.72,
                        primary_code_confidence: -1,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "N97.9",
                                automate: false,
                                confidence: 0.72,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.03684521443722452,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil find",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 155,
                                                    level: "ngram",
                                                    content: "infertility\n   \n   FINDINGS"
                                                },
                                                {
                                                    start: 97,
                                                    end: 155,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.032156570064761934,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil find",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 155,
                                                    level: "ngram",
                                                    content: "infertility\n   \n   FINDINGS"
                                                },
                                                {
                                                    start: 97,
                                                    end: 155,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.029251550076432157,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 139,
                                                    level: "ngram",
                                                    content: "infertility"
                                                },
                                                {
                                                    start: 97,
                                                    end: 139,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.028055604445263248,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "for infertil",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 124,
                                                    end: 139,
                                                    level: "ngram",
                                                    content: "for infertility"
                                                },
                                                {
                                                    start: 97,
                                                    end: 139,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.025378560968894997,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil uteru",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 169,
                                                    level: "ngram",
                                                    content: "infertility\n   \n   FINDINGS\n       Uterus"
                                                },
                                                {
                                                    start: 97,
                                                    end: 169,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility\n   \n   FINDINGS\n       Uterus"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.02124765283633915,
                                        feature: {
                                            category: "Pelvis",
                                            field: "body_region",
                                            type: "categorical"
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.013708222831058934,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil uteru",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 169,
                                                    level: "ngram",
                                                    content: "infertility\n   \n   FINDINGS\n       Uterus"
                                                },
                                                {
                                                    start: 97,
                                                    end: 169,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility\n   \n   FINDINGS\n       Uterus"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.010641634464522032,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "infertil find",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 128,
                                                    end: 155,
                                                    level: "ngram",
                                                    content: "infertility\n   \n   FINDINGS"
                                                },
                                                {
                                                    start: 97,
                                                    end: 155,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility\n   \n   FINDINGS"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.010082192037320824,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "for infertil",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 124,
                                                    end: 139,
                                                    level: "ngram",
                                                    content: "for infertility"
                                                },
                                                {
                                                    start: 97,
                                                    end: 139,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility"
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.007357190147892673,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "for",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 87,
                                                    end: 90,
                                                    level: "ngram",
                                                    content: "FOR"
                                                },
                                                {
                                                    start: 87,
                                                    end: 96,
                                                    level: "sentence",
                                                    content: "FOR TESTS"
                                                },
                                                {
                                                    start: 124,
                                                    end: 127,
                                                    level: "ngram",
                                                    content: "for"
                                                },
                                                {
                                                    start: 97,
                                                    end: 139,
                                                    level: "sentence",
                                                    content: "       Baseline assessment for infertility"
                                                }
                                            ]
                                        }
                                    }
                                ],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: 1
        },
        modifiers: {
            confidence: 0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.72,
            primary_code_confidence: 0.97,
            primary_predicted_code: "N97.9",
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    }
];
exports.atCoder = atCoder;
//# sourceMappingURL=at-coder.fixture.js.map